<template>
  <tbody>
    <template v-for="(bodyItem, bodyIndex) in array">
      <slot name="beforeTblock" :item="bodyItem" />

      <w-tblock :key="bodyIndex" :model="isArray ? bodyItem.$item : model" :index="bodyIndex" v-bind="_props">
        <template v-slot:Lp>
          <slot name="Lp" />
        </template>

        <template v-for="slot in tbSlots" :slot="slot" slot-scope="{item, property, propertyName}">
          <slot :name="slot" :item="item" :property="property" :property-name="propertyName" />
        </template>

        <template v-slot:RowBtns>
          <slot name="RowBtns" />
        </template>
      </w-tblock>

      <slot name="afterTblock" :item="bodyItem" />
    </template>

    <tr v-if="isArray && addRow" v-show="!model.$schema.maxItems || model.$schema.maxItems > model.$items.length">
      <td :colspan="colspan || flatProperties.length + areLp + areRowBtns">
        <w-add-row :model="model">{{ addRow }}</w-add-row>
      </td>
    </tr>
  </tbody>
</template>

<script>
import tableMixin from '../mixins/tableMixin';

export default {
  name: 'w-tbody',
  mixins: [tableMixin],
  props: {
    addRow: {
      type: [String, Boolean],
      default: 'Dodaj wiersz'
    },
    colspan: {
      type: Number,
      default: 0
    }
  },
  computed: {
    array() {
      return this.isArray ? this.model.$items : [this.model];
    }
  }
};
</script>
